import React from 'react';
import PropTypes from 'prop-types';
import { valueOrPlaceholder, isPresent } from 'helpers/string_helpers';
import PhoneList from '../phone_list';

export default class PersonBody extends React.Component {
  static propTypes = {
    record: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
  }

  renderAddress() {
    const { record } = this.props;

    const addressThreeLine = (record.address || {}).threeLine;

    return (
      <div className="col-md-12">
        <div className="preview-title">Office</div>
        <div className="preview-text">
          {isPresent(addressThreeLine) ?
            <React.Fragment>
              {isPresent(addressThreeLine[0]) && <div>{addressThreeLine[0]}</div>}
              {isPresent(addressThreeLine[1]) && <div>{addressThreeLine[1]}</div>}
              {isPresent(addressThreeLine[2]) && <div>{addressThreeLine[2]}</div>}
            </React.Fragment>
            : <div>
              {valueOrPlaceholder(addressThreeLine)}
            </div>
          }
        </div>
      </div>
    );
  }

  renderPhoneNumbers() {
    const { record: { name, phoneNumbers }, user } = this.props;
    if (phoneNumbers.length === 0) return;

    return (
      <div className="col-md-12">
        <div className="preview-title">Phone</div>
        <div className="preview-text">
          <PhoneList name={name} phoneNumbers={phoneNumbers} user={user}/>
        </div>
      </div>
    );
  }

  render() {
    const { record } = this.props;
    return (
      <div className="preview-overlay-body">
        <div className="row">
          <div className="col-md-12">
            <div className="preview-title">Website</div>
            <div className="preview-text">
              {isPresent(record.url) ?
                <a href={record.url}>{valueOrPlaceholder(record.url)}</a>
                : <span>{valueOrPlaceholder(record.url)}</span>
              }
            </div>
          </div>
          {this.renderPhoneNumbers()}
          <div className="col-md-12">
            <div className="preview-title">Email</div>
            <div className="preview-text">
              {valueOrPlaceholder(record.email)}
            </div>
          </div>
          {this.renderAddress()}
          <div className="col-md-12">
            <div className="preview-title">Company Industry</div>
            <div className="preview-text">
              {valueOrPlaceholder(record.industry)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

